import { useQuery } from 'react-query';
import { getDrug } from 'src/services/api/drugs';

function useGetDrug(drug) {
  return useQuery(['drug', drug], (key, drug) => getDrug(drug));
}

export default useGetDrug;
